import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import {
  Row,
  Col,
  Table,
  FormControl,
  FormGroup,
  InputGroup,
  Button,
  DropdownButton,
  MenuItem,
  Label,
} from 'react-bootstrap';
import { injectIntl, FormattedNumber, FormattedDate } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import moment from 'moment';
import 'moment-timezone';

import RoundImage from 'components/layout/RoundImage';
import Pagination from 'components/layout/Pagination';
import ClientListInfo from 'components/layout/ClientListInfo';

import List from 'components/List';

class Payments extends React.Component {
  handleRowClick = (jobId, invoiceId) => {
    // change the url to display the invoice
    this.props.history.push(this.props.appIntl.urlPrefix + 'account/jobs/' + jobId + '/invoices/' + invoiceId);
  };

  render() {
    const { intl, appIntl, list } = this.props;
    const messages = intl.messages;

    const columns = [messages.client, messages.status, messages.due, messages.amount];
    let tBody = [];
    let i = 0;
    for (; i < list.data.list.length; i++) {
      const { payment, invoice } = list.data.list[i];
      const job = invoice.job;

      let status = payment.is_paid ? 'paid' : 'unpaid';
      if (status == 'unpaid' && moment(payment.due_date).isBefore(moment())) {
        status = 'late';
      }
      let statusLabel = null;
      switch (status) {
        case 'unpaid':
          statusLabel = (
            <h4 style={{ margin: 0, border: 0 }}>
              <Label>{messages.paymentStatus.unpaid}</Label>
            </h4>
          );
          break;

        case 'paid':
          statusLabel = (
            <h4 style={{ margin: 0, border: 0 }}>
              <Label bsStyle="success">{messages.paymentStatus.paid}</Label>
            </h4>
          );
          break;

        case 'late':
          statusLabel = (
            <h4 style={{ margin: 0, border: 0 }}>
              <Label bsStyle="danger">{messages.paymentStatus.late}</Label>
            </h4>
          );
          break;
      }

      tBody.push(
        <tr key={i} class="clickable" onClick={() => this.handleRowClick(job.id, invoice.id)}>
          <td>
            <ClientListInfo client={job.target} />
          </td>
          <td>{statusLabel}</td>
          <td>
            <FormattedDate value={new Date(moment.tz(payment.due_date, 'UTC').tz(this.props.user.profile.timezone))} />
          </td>
          <td>
            <FormattedNumber value={payment.amount} style="currency" currency={invoice.currency} />
          </td>
        </tr>
      );
    }

    const resultTable = list.pending ? (
      <div class="text-center">
        <i class="fa fa-circle-notch fa-spin fa-fw" />
      </div>
    ) : (
      <Table responsive hover>
        <thead>
          <tr>
            {columns.map((column, i) => {
              return (
                <th key={i} class={column == messages.actions ? 'text-right' : ''}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return (
      <List
        listName="payments"
        url="/api/payments.json"
        list={this.props.list}
        title={messages.payments}
        iconClass="fa fa-credit-card"
        showNew={false}
        newText={''}
        newAction={false}
        showSearch
        sortOptions={['dueDate,asc']}
      >
        {resultTable}
      </List>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.payments,
    user: state.login.user,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(Payments)));
